/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var taricQuota= angular.module('taric.quota', ['taric.quota.search', 'taric.quota.view']);
taricQuota.config(function ($stateProvider) {
    $stateProvider.state('taric.quota', {
                    abstract: true,
                    url: '/quota',
                    template: '<ui-view></ui-view>'
                }).state('taric.quota.search', {
                    url: '/search?sd&on&co&qs&c&l&frm',
                    templateUrl: 'taric/quota/search/quota-search.tmpl.html',
                    controller : 'SearchTaricQuotaController as searchTaricQuotaCtrl',
                    reloadOnSearch: false,
                    resolve: {
                        initializeData : function(TaricQuotaSearchModel, $stateParams, $translate, CommonHelper){
                            if ($stateParams.frm !== 'taric.quota.view') {
                                TaricQuotaSearchModel.reset();
                            }

                            if ($stateParams.sd){
                                var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                                if (inputDate) {
                                    TaricQuotaSearchModel.getSearchCriteria().simulationDate = inputDate;
                                }
                            }

                            if ($stateParams.on) {
                                TaricQuotaSearchModel.getSearchCriteria().orderNumber = $stateParams.on;
                            }

                            if ($stateParams.co) {
                                TaricQuotaSearchModel.getSearchCriteria().country = $stateParams.co;
                            }

                            if ($stateParams.qs) {
                                TaricQuotaSearchModel.getSearchCriteria().status = $stateParams.qs;
                            }

                            if ($stateParams.c) {
                                if ($stateParams.c === 'true') {
                                    TaricQuotaSearchModel.getSearchCriteria().critical = true;
                                } else {
                                    TaricQuotaSearchModel.getSearchCriteria().critical = false;
                                }
                            }

                            if ($stateParams.l){
                                $translate.use($stateParams.l);
                            }
                        },
                        countries: function(GeographicalAreaModel, TaricQuotaSearchModel, $stateParams){
                            var result = null;
                            // Only get countries to support bookmark when there are required parameters.
                            if (!$stateParams.frm && ($stateParams.sd || $stateParams.on) && $stateParams.co) {
                                result = GeographicalAreaModel.getCountriesOfOrigin(TaricQuotaSearchModel.getSearchCriteria().simulationDate);
                            }
                            return result;
                        },
                        loadTranslation: function ($translatePartialLoader) {
                            $translatePartialLoader.addPart('taric/quota');
                        },
                        setupMenu: function (MenuModel) {
                        	
                        	MenuModel.setHelpIndex(this.name);
                        	MenuModel.notifyObservers();
                        }
                    }

                }).state('taric.quota.view', {
                    url: '/view',
                    templateUrl: 'taric/quota/view/quota-view.tmpl.html',
                    controller : 'ViewTaricQuotaController as viewTaricQuotaCtrl',
                    resolve: {
                        quotaDefinitionExtendedInfo : function (TaricQuotaSearchModel){
                            return TaricQuotaSearchModel.getSelectedRow();
                        },
                        simulationDate : function (TaricQuotaSearchModel){
                            return TaricQuotaSearchModel.getSearchCriteria().simulationDate;
                        },
                        showCancelButton: function (){
                            return true;
                        },
                        $uibModalInstance : function(){
                            return null;
                        },
                        country: function (TaricQuotaSearchModel){
                            return TaricQuotaSearchModel.getSearchCriteria().country;
                        },
                        setupMenu: function (MenuModel) {
                        	
                        	MenuModel.setHelpIndex(this.name);
                        	MenuModel.notifyObservers();
                        }
                    }
                });

});





// WEBPACK FOOTER //
// ./app/taric/quota/taric-quota.js